import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: React.ReactNode;
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'bg-[#e03c3c] hover:brightness-110 active:scale-95 text-white border-transparent',
  secondary:
    'bg-transparent border border-white/10 hover:bg-white/5 text-on-surface',
  ghost:
    'bg-transparent border-transparent text-on-surface-variant hover:text-on-surface hover:bg-surface-container-high'
};

export default function Button({
  variant = 'primary',
  className = '',
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`font-button text-button px-6 py-3 rounded-[4px] transition-all disabled:opacity-50 disabled:pointer-events-none btn-press-active ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
